import { render, staticRenderFns } from "./activity-bar.vue?vue&type=template&id=a406201a&scoped=true&"
import script from "./activity-bar.vue?vue&type=script&lang=ts&"
export * from "./activity-bar.vue?vue&type=script&lang=ts&"
import style0 from "./activity-bar.vue?vue&type=style&index=0&id=a406201a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a406201a",
  null
  
)

export default component.exports